





















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { DropDownController, BaseApplicationController, WechatController } from '@/services/request.service';
import SiderBarInfo from '@/components/SiderBar.vue';
import { DropDownResponse } from '@/services/__model';
import { getSchoolInfo, isWechat } from '@/utils/utils';
import config from '@/school.config';
import fields from '@/fields.config';

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    SiderBarInfo,
  },
})
export default class ApplicationForm extends Vue {
  public gradeList: Array<DropDownResponse> = [];
  public sectionDateList: any = [];
  public isSaveToDraft: boolean = false;
  public currentYear: string = '';
  public displayYear: string = '';

  public userInfo: any = {};
  public draftInfo: any = {};
  public enquiryData: any = {};

  public currentStep: number = 0;
  public step1Info: any = {};
  public step2Info: any = {};
  public config = config;
  public fields = fields;
  public activityChannelId: number = 0;
  public code: string = '';

  public created(): void {
    this.getParentInfo();
    if (!config[this.school].isCourseCenter) {
      this.getGradeAndSectionDateList();
      this.$store.dispatch('getCampusList');
      this.$store.dispatch('getSchoolLibList');
      this.$store.dispatch('getSchoolYearList');
      this.$store.dispatch('getSourceList');
      this.$store.dispatch('getEnglishList');
      this.$store.dispatch('getIdTypeList');
      this.$store.dispatch('getAcademicQualificationList');
      this.$store.dispatch('getSchoolYearAndSemesterList');
    }
    this.$store.dispatch('getMemberShipList');
    this.$store.dispatch('getCountryWithCodeList');
  }

  public get school() {
    return getSchoolInfo().shortName;
  }

  public get fieldsType() {
    return this.school === 'kcscd' ? 'kcscd' : 'default';
  }

  @Watch('currentStep', { immediate: true })
  public scrollTop(): void {
    const el = document.getElementsByClassName('layout-t')[0]!;
    if (el) {
      el.scrollTop = 0;
    }
  }

  public getGradeAndSectionDateList(): void {
    const isDraft = this.$route.query.isDraft;
    Promise.all([DropDownController.getSectionList(), BaseApplicationController.getSectionDate()]).then(res => {
      console.log(res)
      this.gradeList = res && res[0].data ? res[0].data : [];
      this.sectionDateList = res[1].data && res[1].data.sectionDateList ? res[1].data.sectionDateList : [];
      this.currentYear = res[1].data && res[1].data.currentSchoolYear ? res[1].data.currentSchoolYear : '';
      // this.displayYear = res[1].data && res[1].data.displaySchoolYear ? res[1].data.displaySchoolYear : '';
      if (isDraft) {
        this.getDraft();
      } else {
        this.getEnquiry();
      }
    });
  }

  public getParentInfo(): void {
    if (this.$route.query.studentId) {
      const i = this.$route.query.studentId;
      BaseApplicationController.getRelatedParent(Number(i)).then(res => {
        this.userInfo = res.data ? res.data : {};
      });
    } else {
      BaseApplicationController.getRelatedParent().then(res => {
        this.userInfo = res.data ? res.data : {};
      });
    }
  }

  public getDraft(): void {
    if (this.$route.query.draftId) {
      const i = this.$route.query.draftId;
      this.config[this.school].controller.getDraft(i).then((res: any) => {
        this.draftInfo = res.data ? res.data : {};
      });
    }
  }
  public getEnquiry(): void {
    if (this.$route.query.studentId) {
      const i = this.$route.query.studentId;
      this.config[this.school].controller.getApplicationById(i).then((res: any) => {
        this.enquiryData = res.data ? res.data : {};
      });
    }
  }

  public beforeRouteLeave(to: any, from: any, next: any) {
    if (
      ((config[this.school].isCourseCenter && this.currentStep !== 2) ||
        (!config[this.school].isCourseCenter && this.currentStep !== 3)) &&
      !this.isSaveToDraft
    ) {
      const str: any = this.$t('warningTip.leaveFromForm');
      const answer = window.confirm(str);
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }

  public changeStep(type: string, step: string, values: any): void {
    if (type === 'prev' && this.currentStep - 1 >= 0) {
      this.currentStep -= 1;
    } else if (type === 'next' && this.currentStep + 1 <= 3) {
      this.currentStep += 1;
    }
    if (step === 'step1') {
      this.step1Info = values;
    } else if (step === 'step2') {
      this.step2Info = values;
    }
  }

  public saveToDraft(flag: boolean): void {
    this.isSaveToDraft = flag;
  }
}
